var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9744 1.65813C15.0342 1.47846 14.9875 1.28038 14.8536 1.14646C14.7196 1.01254 14.5216 0.965783 14.3419 1.02567L2.3419 5.02567C2.1775 5.08047 2.0532 5.21648 2.01339 5.38514C1.97357 5.55379 2.02392 5.73103 2.14646 5.85357L4.64646 8.35357C4.84172 8.54883 5.1583 8.54883 5.35356 8.35357C5.54883 8.1583 5.54883 7.84172 5.35356 7.64646L3.42562 5.71852L13.7094 2.29058L10.2815 12.5744L6.85356 9.14646C6.85262 9.14552 6.85168 9.14458 6.85073 9.14365L11.8254 4.87964C12.0351 4.69993 12.0594 4.38428 11.8796 4.17462C11.6999 3.96495 11.3843 3.94067 11.1746 4.12039L4.17461 10.1204C3.98262 10.285 3.94372 10.567 4.08398 10.7774L5.08398 12.2774C5.23716 12.5071 5.5476 12.5692 5.77736 12.416C6.00712 12.2629 6.06921 11.9524 5.91604 11.7227L5.1618 10.5913L6.09414 9.79215C6.10966 9.81366 6.1271 9.83421 6.14646 9.85357L10.1465 13.8536C10.269 13.9761 10.4462 14.0265 10.6149 13.9866C10.7835 13.9468 10.9196 13.8225 10.9744 13.6581L14.9744 1.65813Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8aa06c32c5b9c22e7cd516ef3f08c3da.svg";
export { ForwardRef as ReactComponent };